import { useQuery } from "@tanstack/react-query";

const useVolunteersFromWeb = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: volunteersFromWeb = [],
  } = useQuery({
    queryKey: ["getVolunteersFromWeb"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/web-volunteer`
      );
      const data = await res.json();
      // console.log("volunteers from web", data.data);

      return data.data;
    },
  });

  return [volunteersFromWeb, isLoading, isError, error, isSuccess, refetch];
};

export default useVolunteersFromWeb;
